/*
 *
 * Do not edit directly
 * Generated on Wed, 16 Jul 2025 15:14:59 GMT
 *
 */


const theme = {
  appearances: {
    size: {
      type: 'variant',
      values: [ 'micro', 'small', 'medium', 'large' ]
    },
    viewport: {
      description: 'The size label for the current screen viewport based on the current screen width',
      type: 'state',
      values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
    }
  },
  rules: [
    {
      if: { size: 'micro' },
      tokens: {
        amountFontSize: 24,
        bottomTextFontSize: 12,
        bottomTextLineHeight: 1.2,
        centsFontSize: 16,
        centsLineHeight: 1,
        centsPaddingTop: 2,
        currencySymbolFontSize: 16,
        currencySymbolLineHeight: 1,
        currencySymbolPaddingTop: 2,
        footnoteLinkFontSize: 12,
        footnoteLinkLineHeight: 1,
        footnoteMarginTop: 0,
        rateFontSize: 12,
        rateLineHeight: 2,
        strikeThroughHeight: 2,
        strikeThroughPosition: 18,
        topTextFontSize: 12,
        topTextLineHeight: 1.2
      }
    },
    {
      if: { size: 'small' },
      tokens: {
        amountFontSize: 36,
        centsFontSize: 20,
        centsLineHeight: 1.25,
        currencySymbolFontSize: 20,
        footnoteLinkLineHeight: 1.14285714286,
        rateFontSize: 16,
        rateLineHeight: 1.5,
        strikeThroughHeight: 2,
        strikeThroughPosition: 18,
        topTextFontSize: 14,
        topTextLineHeight: 1.14285714286
      }
    },
    {
      if: { size: 'large' },
      tokens: {
        amountFontSize: 54,
        centsFontName: 'StagSans',
        centsFontSize: 24,
        centsFontWeight: '600',
        currencySymbolFontSize: 32,
        footnoteLinkLineHeight: 1.2,
        rateFontName: 'StagSans',
        rateFontSize: 16,
        rateFontWeight: '600',
        rateLineHeight: 1.5,
        strikeThroughPosition: 27,
        topTextFontSize: 20,
        topTextLineHeight: 1.2
      }
    },
    {
      if: { size: 'large', viewport: [ 'lg', 'xl' ] },
      tokens: {
        centsFontName: 'StagSans',
        centsFontSize: 32,
        centsFontWeight: '700'
      }
    }
  ],
  tokens: {
    alignItemsText: 'flex-start',
    amountFontName: 'StagSans',
    amountFontSize: 44,
    amountFontWeight: '700',
    amountLetterSpacing: 0,
    amountLineHeight: 1,
    bottomLinksMarginLeft: 4,
    bottomTextFontSize: 14,
    bottomTextLineHeight: 1.14285714286,
    bottomTextMarginTop: 0,
    centsFontName: 'StagSans',
    centsFontSize: 24,
    centsFontWeight: '700',
    centsLineHeight: 1,
    centsPaddingTop: 0,
    currencySymbolFontName: 'StagSans',
    currencySymbolFontSize: 24,
    currencySymbolFontWeight: '700',
    currencySymbolLineHeight: 1,
    currencySymbolPaddingTop: 0,
    dividerColor: null,
    fontColor: '#000000',
    fontName: 'StagSans',
    fontWeight: '700',
    footnoteGap: 4,
    footnoteLinkColor: '#000000',
    footnoteLinkFontName: 'StagSans',
    footnoteLinkFontSize: 14,
    footnoteLinkFontWeight: '600',
    footnoteLinkLineHeight: 1.25,
    footnoteMarginTop: 4,
    priceMarginBottom: 0,
    rateFontName: 'StagSans',
    rateFontSize: 16,
    rateFontWeight: '700',
    rateLineHeight: 1.5,
    strikeThroughColor: '#000000',
    strikeThroughHeight: 3,
    strikeThroughPosition: 21,
    topTextFontName: 'StagSans',
    topTextFontSize: 16,
    topTextFontWeight: '700',
    topTextLineHeight: 1.25,
    topTextMarginBottom: 4
  }
}
export default theme
